import { Text, View, Pressable, TextInput, Platform, Dimensions, FlatList, AppStateStatus, AppState, RefreshControl, TouchableOpacity, useWindowDimensions, Alert } from 'react-native';
import DefaultScreen from '../../../components/Global/DefaultScreenView';
import styles from '@stylesheet';
import React, { useEffect, useState, useRef, useCallback, memo, useMemo } from 'react';
import apis from '@api/api';
import { useQuery, focusManager } from '@tanstack/react-query';
import getId from '@api/getId';
import filter from 'lodash.filter';
import { useDataContentQuery, createPaginationState, updatePaginationState, resetPaginationPage } from '@utils/dataQueries';
import { Pagination } from '@components/Global/Pagination/Pagination';
import ProductionDataTable from '@components/DataTable/ProductionDataTable';
import { generateColumnsFromData } from '@components/DataTable/tableUtils';
import DefaultCustomer from '../MidLevel/DataScreen/components/DefaultCustomer';
import * as Animatable from 'react-native-animatable';
import DefaultProduct from '../MidLevel/DataScreen/components/DefaultProduct';
import DefaultDocument from '../MidLevel/DataScreen/components/DefaultDocument';
import BottomSheet, {
  BottomSheetModal,
  BottomSheetModalProvider,
  BottomSheetView,
} from '@gorhom/bottom-sheet';
import AddDataModal, { AddDataModalHandle } from './Components/AddDataModal';
import Button from '../../../components/UI/Button/Button';
import SearchComponent from '../../../components/Global/SearchComponent/SearchBar';
import { PanGestureHandler, State } from 'react-native-gesture-handler';
import Animated, {
  useSharedValue,
  withSpring,
} from 'react-native-reanimated';
import { Title } from '@constants/Themed';
import { AntDesign, MaterialIcons, FontAwesome, Ionicons, FontAwesome5, SimpleLineIcons, Entypo } from '@expo/vector-icons';
import Modal from 'react-native-modal';
import HorizontalCarousel from '../../../components/Global/Carousel/HorizontalCarousel';
import { BlurView } from '@react-native-community/blur';
import handleImage from '@utils/handleImage';
import handleCamera from '@utils/handleCamera';
import DefaultDataItem from '../MidLevel/DataScreen/components/DefaultDataItem';
import { Checkbox, SizableText, YStack, Popover, Adapt, ScrollView } from 'tamagui';
import IndividualDataTable from './Components/DataTable';
import { debounce, set, uniqueId } from 'lodash';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { Feather } from '@expo/vector-icons';
import { useSelector } from 'react-redux';
import { DefaultRootState, store } from '@reduxLocal/persistState';
import { useFocusEffect } from '@react-navigation/native';
import useGlobalUser from '@hooks/getGlobalUser';
import { XStack } from 'tamagui';
import { useDeviceType } from '@hooks/useDeviceType';
import ErrorBoundary from '@utils/ErrorBoundary';
import LottieView from 'lottie-react-native';
import { flagItem } from '@api/api';
import { useAlertDialog } from '@components/Global/AlertDialog/useAlertDialog';
import handleDataItemDelete from '../MidLevel/DataScreen/CaptureScreen/utils/handleDataItemDelete';
import handleDataItemMove from '../MidLevel/DataScreen/CaptureScreen/utils/handleDataItemMove';
import DataSetSelection from "@components/Global/DataSetSelection";
import CustomViewRenderer from '../../../components/CustomView/CustomViewRenderer';
import { useQueryClient } from '@tanstack/react-query';
import AvatarHandler from '@components/Global/AvatarHandler/AvatarHandler';
import DataBrowserFilters from './Components/DataBrowserFilters';
import { filterDataItems, DataFilterOptions, resetFilters, hasActiveFilters } from './utils/dataFilters';
import moment from 'moment';
// Removed Virtuoso import - using FlatList instead

interface DefaultData {
  createdAt?: string;
  dataTitle?: string;
  dataSchema?: any;
  _id?: string;
  createdBy?: string;
}

const DataBrowserScreen = ({ route, navigation }) => {
  // #region agent log
 
  // #endregion
  const [scrollDisabled, setScrollDisabled] = useState(false)
  const [disabledState, setDisabledState] = useState(true)
  const { requestId, title, type } = route.params;
  const isDocumentType = type === 'document';
  const activeItem = useSelector((state: DefaultRootState) => state.app.activeItem)
  const [retrievedData, setRetrievedData] = useState();
  const [query, setQuery] = useState('');
  const [defaultData, setDefaultData] = useState<DefaultData>({});
  const [searchFocused, setSearchFocused] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const bottomDrawerRef = useRef<BottomSheet | AddDataModalHandle>(null);
  const [searchState, setSearchState] = useState("");
  const [showStats, setShowStats] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [renderedData, setRenderedData] = useState([]);
  const initialLoadItemCount = 10; // Initial number of items to load
  const [extraImageVisible, setExtraImageVisible] = useState(false);
  const [itemTags, setItemTags] = useState([]);
  const [listWidth, setListWidth] = useState(0);
  const theme = themeSelector();
  const [listHorizontal, setListHorizontal] = useState(false);
  const markedRef = useRef([]);
  const { showConfirm, showAlert } = useAlertDialog();
  const queryClient = useQueryClient();
  


  // Custom view states
  const [selectedCustomView, setSelectedCustomView] = useState<string | null>(null);
  const [customViews, setCustomViews] = useState([]);

  // Filter states
  const [filters, setFilters] = useState<DataFilterOptions>(resetFilters());
  const [showFilters, setShowFilters] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');


  useFocusEffect(() => {
    const unsubscribe = store.subscribe(() => {
      const lastAction = store.getState().lastAction;
      if (lastAction && lastAction.type === 'UPDATE' && Platform.OS === 'web') {
        refetch(); // Assuming refetch is defined somewhere in your component
      }
    });

    return () => {
      unsubscribe(); // Unsubscribe when the component unmounts
    };
  });
  // Pagination state using utils
  const [paginationState, setPaginationState] = useState(() =>
    createPaginationState({ currentPage: 1, pageSize: 10 })
  );

  // Query Function for data with pagination
  const {
    data: paginatedData,
    refetch: refetchPaginated,
    isLoading: paginatedLoading
  } = useDataContentQuery({
    selectedId: requestId,
    pagination: paginationState,
    enabled: !isDocumentType && !!requestId
  });

  // Fallback query that works without pagination
  const {
    data: fallbackData,
    isLoading: fallbackLoading,
    refetch: refetchFallback
  } = useQuery({
    queryKey: [`individualData-fallback`, requestId, type],
    queryFn: async () => {
      const { data } = await apis.getDataContent(route.params.requestId, type);
      const { dataContent, dataTags, customViews } = data;
      if (dataContent) {
          setRetrievedData(dataContent);
          setRenderedData(dataContent);
        }

        if (dataTags) {
          setItemTags(dataTags);
        }

      if (customViews && Array.isArray(customViews)) {
        setCustomViews(customViews);
      }

        setDefaultData(data);
      return data;
    },
    enabled: isDocumentType ? !!requestId : (!paginatedData && !!requestId), // Run when viewing documents or when paginated data absent
    retry: 0
  });

  // Use paginated data if available, otherwise fallback
  const finalData = isDocumentType ? fallbackData : (paginatedData || fallbackData);
  const isLoading = isDocumentType ? fallbackLoading : paginatedLoading;
  const refetch = isDocumentType ? refetchFallback : refetchPaginated;

  // Process data from API response with pagination
  useEffect(() => {
    if (finalData) {
      console.log('DataBrowserScreen: Processing finalData:', {
        finalData,
        hasData: !!finalData.data,
        dataKeys: Object.keys(finalData.data || {}),
        dataContent: finalData.data?.dataContent,
        dataContentLength: finalData.data?.dataContent?.length || 0
      });

      // Handle both paginated and fallback data structures
      const responseData = finalData?.data || finalData;
      let { dataContent, dataTags, customViews } = responseData || {};

      if (isDocumentType && Array.isArray(dataContent)) {
        const targetId = requestId?.toString?.() ?? requestId;
        dataContent = dataContent
          .filter((doc) => doc?.isSigned && (doc?.parent?.toString?.() ?? doc?.parent) === targetId)
          .map((doc) => ({
            ...doc,
            parent: doc?.parent?.toString?.() ?? doc?.parent
          }));
      }

      console.log('DataBrowserScreen: Extracted data:', {
        dataContent,
        dataContentLength: dataContent?.length || 0,
        dataTags,
        customViews
      });

      if (dataContent && Array.isArray(dataContent)) {
        console.log('DataBrowserScreen: Setting data content:', dataContent.length, 'items');
        setRetrievedData(dataContent);
        // For pagination, we only show the current page data
        setRenderedData(dataContent);
      } else {
        console.log('DataBrowserScreen: No valid dataContent found');
      }

      if (dataTags) {
        setItemTags(dataTags);
      }

      if (customViews && Array.isArray(customViews)) {
        setCustomViews(customViews);
      }

      setDefaultData(finalData);
    }
  }, [finalData]);

  // Handle pagination changes
  useEffect(() => {
    console.log('Pagination changed, refetching data...', paginationState);
    // The useDataContentQuery will automatically refetch when paginationState changes
  }, [paginationState]);

  // Debug logging for pagination
  useEffect(() => {
    console.log('DataBrowserScreen Debug:', {
      requestId,
      paginationState,
      data: paginatedData ? {
        hasData: !!paginatedData.data,
        dataLength: paginatedData.data?.length || 0,
        pagination: paginatedData.pagination,
        fullData: paginatedData
      } : null,
      finalData: finalData ? {
        hasData: !!finalData.dataContent,
        dataLength: finalData.dataContent?.length || 0,
        pagination: finalData.pagination,
        fullData: finalData
      } : null,
      isLoading,
      error: paginatedData?.error
    });
  }, [requestId, paginationState, paginatedData, finalData, isLoading]);

  // Test pagination state changes
  useEffect(() => {
    console.log('Pagination state changed:', paginationState);
  }, [paginationState]);

  // Pagination handlers
  const handlePageChange = useCallback((page: number) => {
    setPaginationState(prev => updatePaginationState(prev, { currentPage: page }));
  }, []);

  const handlePageSizeChange = useCallback((pageSize: number) => {
    setPaginationState(prev => resetPaginationPage(updatePaginationState(prev, { pageSize })));
  }, []);

  const handleSortByChange = useCallback((sortBy: string) => {
    setPaginationState(prev => resetPaginationPage(updatePaginationState(prev, { sortBy })));
  }, []);

  const handleSortOrderChange = useCallback((sortOrder: 'asc' | 'desc') => {
    setPaginationState(prev => resetPaginationPage(updatePaginationState(prev, { sortOrder })));
  }, []);

  const _handleAddItem = useCallback((item) => {
    setRetrievedData((prevData) => {
      // Check if prevData is an array before spreading
      const newData = Array.isArray(prevData) ? [...prevData, item] : [item];
      return newData;
    });
  }, [retrievedData]);


  const handleStatsSwitch = useCallback((value) => {
    setShowStats(value);
  }, [])

  // Refresh function
  const onRefresh = useCallback(() => {
    setRefreshing(true);
    refetch().finally(() => setRefreshing(false));
  }, [refetch]);

  const _handleTableSwitch = useCallback(() => {
    setShowTable(!showTable);
  }, [showTable])

  // Apply filters and search to data
  const applyFiltersAndSearch = useCallback((query: string = searchQuery) => {
    if (!retrievedData || !Array.isArray(retrievedData)) {
      setRenderedData([]);
      return;
    }

    // Apply filters and search
    const filtered = filterDataItems(retrievedData, filters, query);
    setRenderedData(filtered);
  }, [retrievedData, filters, searchQuery]);

  //Search function for data
  const handleSearch = useCallback((text = "") => {
    setSearchQuery(text);
    applyFiltersAndSearch(text);
  }, [applyFiltersAndSearch]);

  // Update rendered data when filters or retrieved data changes
  useEffect(() => {
    applyFiltersAndSearch();
  }, [applyFiltersAndSearch]);

  // Handle filter changes
  const handleApplyFilters = useCallback((newFilters: DataFilterOptions) => {
    setFilters(newFilters);
  }, []);

  //TODO Search through entire schema
  const contains = (data, query) => {
    query = query.replace(/ /g, '_').toLowerCase(); // Replace spaces with underscores and convert to lowercase

    const searchNestedObject = (obj) => {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];

          if (value !== null && typeof value === 'object') {
            // Recursively search nested objects
            if (searchNestedObject(value)) {
              return true;
            }
          } else {
            // Check if the string representation of the value includes the query
            if (value && value.toString().toLowerCase().includes(query)) {
              return true;
            }
          }
        }
      }

      return false;
    };

    return searchNestedObject(data);
  };

  const handleEtraImageVisible = useCallback(() => {
    setExtraImageVisible(!extraImageVisible);
  }, [extraImageVisible])

  const CustomerImageModal = () => {
    return (
      <Modal animationIn={'zoomIn'} isVisible={extraImageVisible} backdropColor='transparent' onBackdropPress={() => setExtraImageVisible(false)} style={[styles.modalContainerAuth, styles.centerEverything, { maxHeight: '40%', maxWidth: '80%', alignSelf: 'center', justifyContent: 'center', margin: '40%', top: 100, left: 25, backgroundColor: '#ffffff66' }]}>
        <BlurView style={styles.blurViewStyle} blurType="light" blurAmount={10} reducedTransparencyFallbackColor="white" pointerEvents='none' />
        <View style={{ flex: 1, left: 105, borderRadius: 20, gap: 50 }}>
          <View style={{ flex: 7, top: -30 }}>
            <HorizontalCarousel images={[]} width={400} height={400} />
          </View>
          <View style={{ left: -7, flexDirection: 'row', paddingHorizontal: 30 }}>
            <Button customStyle={{ flex: 1, minWidth: 150, minHeight: 40, left: -100, top: -30 }} textColor='white' iconColor='white' buttonText={"Camera"} icon={<MaterialIcons name="add-a-photo" size={24} color="black" />}
              onPress={handleCamera} />
            <Button customStyle={{ flex: 1, minWidth: 150, minHeight: 40, left: -100, top: -30 }} iconStyle={{ left: 0 }} textColor='white' iconColor='white' buttonText={"Upload"} icon={<FontAwesome name="photo" size={24} color="black" />}
              onPress={handleImage} />
          </View>
        </View>
      </Modal>
    )
  }

  const changeListView = useCallback(() => {
    setListHorizontal(!listHorizontal);
  }, [listHorizontal]);

  // Get current user from Redux
  const currentUserData = useSelector((state: DefaultRootState) => state.promiseData.data?.userData);

  // Get available users for filter
  const getAvailableUsersForFilter = useCallback(() => {
    const queryKey = ['all-users', { filter: 'default', externalFilter: false, page: 1, limit: 50 }];
    const allUsers = queryClient.getQueryData(queryKey) as any[] || [];

    const formattedUsers = (Array.isArray(allUsers) ? allUsers : [])
      .filter((user: any) => {
        const hasId = user._id || user.id || user.user?._id || user.user?.id;
        const isPending = user.isPending === true || user.role === 'pending' || user.status === 'pending' ||
          user.user?.isPending === true || user.user?.role === 'pending' || user.user?.status === 'pending';
        return hasId && !isPending;
      })
      .map((user: any) => {
        const userObj = user.user || user;
        const userId = userObj._id || userObj.id || user._id || user.id;
        const userName = userObj.profile_information?.name || userObj.name || user.profile_information?.name || user.name || '';
        const userSurname = userObj.profile_information?.surname || userObj.surname || user.profile_information?.surname || user.surname || '';
        const userEmail = userObj.email || user.email || '';
        const fullName = `${userName} ${userSurname}`.trim() || userEmail || 'Unknown User';

        return {
          _id: userId,
          label: fullName,
          email: userEmail
        };
      });

    // Add current user if not in list
    if (currentUserData?.id) {
      const currentUserId = currentUserData.id.toString();
      const isInList = formattedUsers.some(u => u._id?.toString() === currentUserId);
      if (!isInList) {
        const currentUserName = currentUserData.name || '';
        const currentUserSurname = currentUserData.surname || '';
        const currentUserEmail = currentUserData.email || '';
        const currentUserFullName = `${currentUserName} ${currentUserSurname}`.trim() || currentUserEmail || 'You';
        formattedUsers.unshift({
          _id: currentUserId,
          label: currentUserFullName,
          email: currentUserEmail
        });
      }
    }

    return formattedUsers;
  }, [queryClient, currentUserData]);

  const RenderItem = ({ item, index, checkCallback }) => {
    const [showLoc, setShowLoc] = useState(false);
    const [marked, setMarked] = useState(false);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [availableUsers, setAvailableUsers] = useState<any[]>([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);
    const [deadlineDatePickerOpen, setDeadlineDatePickerOpen] = useState(false);
    const [selectedUserForDeadline, setSelectedUserForDeadline] = useState<{ userId: string; itemId: string } | null>(null);
    const [deadlineDate, setDeadlineDate] = useState(new Date());
    const { isTablet } = useDeviceType();
    const tablet = isTablet;
    // Get current user from Redux
    const currentUserData = useSelector((state: DefaultRootState) => state.promiseData.data?.userData);

    // Get assigned user info - using same source as LazyMessages
    const getAssignedUserInfo = useCallback(() => {
      const assignedToId = item.assignedTo || item.data?.assignedTo;
      if (!assignedToId) return null;

      // Check if assigned to current user
      if (currentUserData?.id && (currentUserData.id.toString() === assignedToId.toString())) {
        const userName = currentUserData.name || '';
        const userSurname = currentUserData.surname || '';
        const userEmail = currentUserData.email || '';
        const userAvatar = currentUserData.avatar?.img || null;
        const fullName = `${userName} ${userSurname}`.trim() || userEmail || 'You';
        
        return {
          _id: assignedToId,
          name: fullName,
          email: userEmail,
          avatar: userAvatar
        };
      }

      // Use the same user list source as LazyMessages
      const queryKey = ['all-users', { filter: 'default', externalFilter: false, page: 1, limit: 50 }];
      const allUsers = queryClient.getQueryData(queryKey) as any[] || [];

      // Find the assigned user in the list (handle both direct user objects and nested user objects)
      const assignedUser = (Array.isArray(allUsers) ? allUsers : []).find((user: any) => {
        const userId = user.user?._id || user._id || user.id;
        return userId === assignedToId || userId?.toString() === assignedToId?.toString();
      });

      if (assignedUser) {
        // Handle nested user structure (from messaging API)
        const userObj = assignedUser.user || assignedUser;
        const userName = userObj.profile_information?.name || userObj.name || '';
        const userSurname = userObj.profile_information?.surname || userObj.surname || '';
        const userEmail = userObj.email || assignedUser.email || '';
        const userAvatar = userObj.profile_information?.avatar?.img || userObj.avatar?.img || assignedUser.avatar?.img || null;
        
        const fullName = `${userName} ${userSurname}`.trim() || userEmail || 'Unknown User';
        
        return {
          _id: assignedToId,
          name: fullName,
          email: userEmail,
          avatar: userAvatar
        };
      }

      // Fallback if user not found in cache
      return {
        _id: assignedToId,
        name: 'Assigned User',
        email: '',
        avatar: null
      };
    }, [item, queryClient, currentUserData]);

    const assignedUser = getAssignedUserInfo();

    // Debug: Log when availableUsers changes
    useEffect(() => {
      console.log('🔄 availableUsers state changed:', {
        count: availableUsers.length,
        users: availableUsers.map(u => ({ _id: u._id, label: u.label }))
      });
    }, [availableUsers]);

    // Load users when popover opens
    const loadUsers = useCallback(async () => {
      console.log('🚀 loadUsers CALLED (WEB)', { isLoadingUsers, availableUsersLength: availableUsers.length });
      if (isLoadingUsers) {
        console.log('⏸️ Already loading, skipping...');
        return;
      }
      
      console.log('▶️ Starting to load users...');
      setIsLoadingUsers(true);
      try {
        // Try to find cached data with different query key variations
        const possibleKeys = [
          ['all-users', { filter: 'default', externalFilter: false, page: 1, limit: 50 }],
          ['all-users', { filter: 'default', externalFilter: false }],
          ['all-users', { externalFilter: false, page: 1, limit: 50 }],
        ];
        
        let allUsers: any[] = [];
        for (const queryKey of possibleKeys) {
          const cached = queryClient.getQueryData(queryKey) as any[];
          if (cached && Array.isArray(cached) && cached.length > 0) {
            allUsers = cached;
            console.log('✅ Found cached users:', { count: allUsers.length, queryKey });
            break;
          }
        }
        
        // If cache is empty, fetch from API
        if (!allUsers || allUsers.length === 0) {
          console.log('📞 Fetching users from API...');
          const response = await apis.getAllMessagingUsers(1, 50, false);
          console.log('📡 API response:', {
            hasResponse: !!response,
            hasData: !!response?.data,
            dataLength: response?.data?.length,
            responseKeys: response ? Object.keys(response) : []
          });
          
          allUsers = response?.data || [];
          
          if (allUsers.length > 0 && Array.isArray(allUsers)) {
            // Cache with the standard key format
            queryClient.setQueryData(possibleKeys[0], allUsers);
            console.log('✅ Cached users:', { count: allUsers.length });
          }
        }

        console.log('👥 Processing users:', { 
          totalUsers: allUsers.length,
          isArray: Array.isArray(allUsers),
          firstUser: allUsers[0],
          firstUserKeys: allUsers[0] ? Object.keys(allUsers[0]) : [],
          fullResponse: allUsers
        });

        // Filter out invalid and pending users
        let acceptedUsers = (Array.isArray(allUsers) ? allUsers : []);
        
        acceptedUsers = acceptedUsers.filter((user: any) => {
          if (!user) {
            console.log('⚠️ Skipping null/undefined user');
            return false;
          }
          
          // Check if user has a valid ID
          const hasId = user._id || user.id || user.user?._id || user.user?.id;
          if (!hasId) {
            console.log('⚠️ Skipping user without ID:', { user, keys: Object.keys(user || {}) });
            return false;
          }
          
          // Filter out pending users - check multiple possible pending indicators
          const isPending = user.isPending === true || 
                           user.role === 'pending' || 
                           user.status === 'pending' ||
                           user.user?.isPending === true ||
                           user.user?.role === 'pending' ||
                           user.user?.status === 'pending';
          
          if (isPending) {
            console.log('⚠️ Skipping pending user:', { 
              _id: user._id || user.id, 
              role: user.role || user.user?.role,
              status: user.status || user.user?.status,
              isPending: user.isPending || user.user?.isPending
            });
            return false;
          }
          
          return true;
        });

        console.log('✅ Accepted users after filtering:', { 
          count: acceptedUsers.length,
          sampleUser: acceptedUsers[0],
          sampleUserKeys: acceptedUsers[0] ? Object.keys(acceptedUsers[0]) : [],
          allAcceptedUsers: acceptedUsers
        });

        // Format users for selection
        const formattedUsers = acceptedUsers.map((user: any) => {
          const userObj = user.user || user;
          const userId = userObj._id || userObj.id || user._id || user.id;
          const userName = userObj.profile_information?.name || userObj.name || user.profile_information?.name || user.name || '';
          const userSurname = userObj.profile_information?.surname || userObj.surname || user.profile_information?.surname || user.surname || '';
          const userEmail = userObj.email || user.email || '';
          const userAvatar = userObj.profile_information?.avatar?.img || 
                           userObj.avatar?.img || 
                           user.profile_information?.avatar?.img || 
                           user.avatar?.img || 
                           null;
          
          const fullName = `${userName} ${userSurname}`.trim() || userEmail || 'Unknown User';
          
          return {
            _id: userId,
            value: userId,
            label: fullName,
            email: userEmail,
            avatar: userAvatar,
            user: userObj
          };
        });

        // Remove duplicates
        const uniqueUsers = formattedUsers.filter((user, index, self) => 
          index === self.findIndex((u) => {
            const id1 = u._id?.toString();
            const id2 = user._id?.toString();
            return id1 && id2 && id1 === id2;
          })
        );

        // Add current user if not already in the list
        if (currentUserData?.id) {
          const currentUserId = currentUserData.id.toString();
          const isCurrentUserInList = uniqueUsers.some(u => 
            u._id?.toString() === currentUserId
          );
          
          if (!isCurrentUserInList) {
            const currentUserName = currentUserData.name || '';
            const currentUserSurname = currentUserData.surname || '';
            const currentUserEmail = currentUserData.email || '';
            const currentUserAvatar = currentUserData.avatar?.img || null;
            const currentUserFullName = `${currentUserName} ${currentUserSurname}`.trim() || currentUserEmail || 'You';
            
            uniqueUsers.unshift({
              _id: currentUserId,
              value: currentUserId,
              label: currentUserFullName,
              email: currentUserEmail,
              avatar: currentUserAvatar,
              user: currentUserData
            });
            console.log('✅ Added current user to list:', { 
              _id: currentUserId, 
              label: currentUserFullName 
            });
          }
        }

        console.log('✅ Final unique users:', { 
          count: uniqueUsers.length,
          users: uniqueUsers.map(u => ({ _id: u._id, label: u.label, email: u.email })),
          fullList: uniqueUsers
        });
        
        console.log('🔧 About to set availableUsers state with:', uniqueUsers.length, 'users');
        setAvailableUsers(uniqueUsers);
        console.log('✅ State setAvailableUsers called with:', uniqueUsers.length, 'users');
      } catch (error) {
        console.error('❌ Error loading users:', error);
        showAlert('Error', 'Failed to load users. Please try again.');
        setAvailableUsers([]);
      } finally {
        setIsLoadingUsers(false);
      }
    }, [queryClient, showAlert, isLoadingUsers, currentUserData]);

    // Handle popover open
    const handlePopoverOpen = useCallback((open: boolean) => {
      console.log('🔓 handlePopoverOpen called (WEB):', { open, currentUserCount: availableUsers.length });
      setPopoverOpen(open);
      if (open) {
        // Always reload users when opening popover to ensure fresh data
        console.log('🔓 Popover opened, calling loadUsers...', { currentUserCount: availableUsers.length });
        loadUsers();
      } else {
        console.log('🔒 Popover closed');
      }
    }, [loadUsers, availableUsers.length]);

    // Handle user selection and update data item
    const handleUserSelection = useCallback(async (userId: string | null, itemId: string, deadline?: Date) => {
      try {
        // Get current item data
        const currentItem = renderedData.find((d) => d._id === itemId);
        const currentData = currentItem?.data || {};
        
        // Update the data item with assignedTo field (stored in data object)
        const updateValues = {
          ...currentData,
          assignedTo: userId || null,
          deadline: deadline ? deadline.toISOString() : (currentData.deadline || null)
        };
        
        await apis.updateDataItem(itemId, updateValues);
        
        // Update local state - update both top-level and data.assignedTo for compatibility
        setRenderedData((prevData) => {
          return prevData.map((data) => {
            if (data._id === itemId) {
              return { 
                ...data, 
                assignedTo: userId,
                deadline: deadline ? deadline.toISOString() : (data.deadline || null),
                data: {
                  ...(data.data || {}),
                  assignedTo: userId,
                  deadline: deadline ? deadline.toISOString() : (data.data?.deadline || null)
                }
              };
            }
            return data;
          });
        });

        setRetrievedData((prevData) => {
          return prevData.map((data) => {
            if (data._id === itemId) {
              return { 
                ...data, 
                assignedTo: userId,
                deadline: deadline ? deadline.toISOString() : (data.deadline || null),
                data: {
                  ...(data.data || {}),
                  assignedTo: userId,
                  deadline: deadline ? deadline.toISOString() : (data.data?.deadline || null)
                }
              };
            }
            return data;
          });
        });

        // Create calendar event if deadline is set and user is assigned
        if (userId && deadline) {
          try {
            // Get user's calendars
            const calendarsResponse = await apis.getCalendars();
            const calendars = calendarsResponse?.data || [];

            if (calendars.length > 0) {
              // Use the first available calendar
              const calendar = calendars[0];
              const calendarId = calendar._id || calendar.calendarId;

              // Get item title for the event
              const itemTitle = currentItem?.data?.title || currentItem?.data?.name || currentItem?.dataTitle || 'Data Item';

              // Create calendar event with link to data item
              const calendarEvent = {
                calendarId: calendarId,
                title: `Complete: ${itemTitle}`,
                summary: `Deadline for data item: ${itemTitle}\n\nView item: ${Platform.OS === 'web' ? (typeof window !== 'undefined' ? window.location.origin : '') : ''}/data/${requestId}/item/${itemId}`,
                startDate: moment(deadline).startOf('day').toDate(),
                endDate: moment(deadline).endOf('day').toDate(),
                allDay: true,
                availability: 'busy',
                // Store link to data item in metadata
                metadata: {
                  dataItemId: itemId,
                  dataId: requestId,
                  type: 'data_item_deadline',
                  link: `/data/${requestId}/item/${itemId}`
                }
              };

              await apis.addCalendarEntry(calendarEvent, currentUserData?.id);
            }
          } catch (calendarError) {
            console.error('Error creating calendar event:', calendarError);
            // Don't fail the assignment if calendar creation fails
          }
        }

        if (userId) {
          // Get user name from the same source as LazyMessages
          const queryKey = ['all-users', { filter: 'default', externalFilter: false, page: 1, limit: 50 }];
          const allUsers = queryClient.getQueryData(queryKey) as any[] || [];
          const user = (Array.isArray(allUsers) ? allUsers : []).find((u: any) => {
            const uId = u.user?._id || u._id || u.id;
            return uId === userId || uId?.toString() === userId?.toString();
          });
          
          const userObj = user?.user || user;
          const userName = userObj?.profile_information?.name || userObj?.name || userObj?.email || 'User';
          const message = deadline
            ? `Item assigned to ${userName} with deadline ${moment(deadline).format('MMM DD, YYYY')}`
            : `Item assigned to ${userName}`;
          showAlert('Success', message);
        } else {
          showAlert('Success', 'Item unassigned');
        }
      } catch (error) {
        console.error('Error assigning user:', error);
        showAlert('Error', 'Failed to assign user. Please try again.');
      }
    }, [queryClient, showAlert, renderedData, requestId, currentUserData]);

    // Handle deadline button click
    const handleDeadlineClick = useCallback((userId: string, itemId: string, e: any) => {
      if (e) {
        e.stopPropagation();
        e.preventDefault();
      }
      console.log('📅 Deadline button clicked:', { userId, itemId });
      setSelectedUserForDeadline({ userId, itemId });
      setDeadlineDate(new Date());
      setDeadlineDatePickerOpen(true);
      console.log('📅 Modal state set to true');
    }, []);

    // Handle deadline date confirmation
    const handleDeadlineConfirm = useCallback(async (date: Date) => {
      setDeadlineDatePickerOpen(false);
      if (selectedUserForDeadline) {
        await handleUserSelection(
          selectedUserForDeadline.userId,
          selectedUserForDeadline.itemId,
          date
        );
        setSelectedUserForDeadline(null);
      }
    }, [selectedUserForDeadline, handleUserSelection]);

    const DataType = ({ innerStyle }) => {
      switch (true) {

        case type === 'document':
          return (
            <Animatable.View useNativeDriver animation={'fadeIn'} style={[styles.dataBrowserItemStyle, { minHeight: 280, paddingRight: 20 }]}>
              <Pressable style={{ flex: 1, backgroundColor: theme ? "white" : "#333333", paddingVertical: 15 }} onLongPress={() => { setDisabledState(false); setScrollDisabled(true) }} onResponderRelease={() => { setDisabledState(true); setScrollDisabled(false) }} onResponderEnd={() => { setDisabledState(true); setScrollDisabled(false) }}>
                <DefaultDocument callback={handleEtraImageVisible} item={item} navigation={navigation} schema={defaultData?.dataSchema} />
              </Pressable >
            </Animatable.View>
          )

        case itemTags.includes('customer'):
        case itemTags.includes('customers'):
        case itemTags.includes('Customer'):
        case itemTags.includes('Customers'):
        case itemTags.includes('client'):
        case itemTags.includes('clients'):
        case itemTags.includes('Client'):
        case itemTags.includes('Clients'):
        case itemTags.includes('contact'):
          case itemTags.includes('Player'):
          case itemTags.includes('player'):
            case itemTags.includes('Players'):
              case itemTags.includes('players'):
                case itemTags.includes('Contact'):
                  case itemTags.includes('User'):

          return (
            <Animatable.View useNativeDriver animation={'fadeIn'} style={[styles.dataBrowserItemStyle, { minHeight: 280, paddingRight: 20 }]}>
              <Pressable style={{ flex: 1, borderRadius: 20, shadowRadius: 5, shadowOpacity: .2, margin: 10, backgroundColor: theme ? "white" : "#333333", paddingVertical: 15 }} onLongPress={() => { setDisabledState(false); setScrollDisabled(true) }} onResponderRelease={() => { setDisabledState(true); setScrollDisabled(false) }} onResponderEnd={() => { setDisabledState(true); setScrollDisabled(false) }}>
                <DefaultCustomer callback={handleEtraImageVisible} item={item} navigation={navigation} schema={defaultData?.dataSchema} />
              </Pressable >
            </Animatable.View>
          );

        case itemTags.includes('products'):
        case itemTags.includes('product'):
        case itemTags.includes('Product'):
        case itemTags.includes('Products'):
        case itemTags.includes('service'):
        case itemTags.includes('services'):
        case itemTags.includes('Service'):
        case itemTags.includes('Services'):
        case itemTags.includes('Property'):
        case itemTags.includes('Properties'):
        case itemTags.includes('property'):
        case itemTags.includes('properties'):
        case itemTags.includes('Listing'):
        case itemTags.includes('listings'):
        case itemTags.includes('listing'):
        case itemTags.includes('Listings'):
          return (
            <Animatable.View useNativeDriver animation={'fadeIn'} style={[styles.dataBrowserItemStyle, { minHeight: 280, paddingRight: 20 }]}>
              <Pressable
                style={{ flex: 1, margin: 10, backgroundColor: theme ? "white" : "#333333", paddingVertical: 15 }}
                onLongPress={() => { setDisabledState(false); setScrollDisabled(true) }}
                onResponderRelease={() => { setDisabledState(true); setScrollDisabled(false) }}
                onResponderEnd={() => { setDisabledState(true); setScrollDisabled(false) }}
                onPress={() => navigation.navigate('ProductScreen', { dataId: requestId, contentId: item._id })}
              >
                <ErrorBoundary>
                  <DefaultProduct innerStyle={innerStyle} item={item} dataId={requestId} navigation={navigation} />
                </ErrorBoundary>
              </Pressable>
            </Animatable.View>
          );

        default:
          // If a custom view is selected, use CustomViewRenderer
          if (selectedCustomView) {
            const customView = customViews.find(view => view._id === selectedCustomView);
            if (customView) {
              return (
                <Animatable.View useNativeDriver animation={'fadeIn'} style={[styles.dataBrowserItemStyle, { minHeight: 280, paddingRight: 20 }]}>
                  <Pressable style={{ flex: 1, borderRadius: 20, shadowRadius: 5, shadowOpacity: .2, margin: 10, backgroundColor: theme ? "white" : "#333333", paddingVertical: 15 }} onPress={() => navigation.navigate('GenericDataItemScreen', { dataId: requestId, contentId: item?._id })}>
                    <CustomViewRenderer customView={customView} dataItem={item} />
                  </Pressable>
                </Animatable.View>
              );
            }
          }

          return (
            <Animatable.View useNativeDriver animation={'fadeIn'} style={[styles.dataBrowserItemStyle, { minHeight: 280, paddingRight: 20 }]}>
              <Pressable style={{ flex: 1, borderRadius: 20, shadowRadius: 5, shadowOpacity: .2, margin: 10, backgroundColor: theme ? "white" : "#333333", paddingVertical: 15 }} onPress={() => navigation.navigate('GenericDataItemScreen', { dataId: requestId, contentId: item?._id })}>
                <DefaultDataItem item={item} navigation={navigation} />
              </Pressable >
            </Animatable.View>
          );
      }
    };

    return useMemo(() => (
      <XStack gap={15} style={{ borderRadius: 20, overflow: "hidden", flex: 1, minHeight: tablet ? undefined : Platform.select({ web: "100%", default: undefined }), zIndex: -index }}>
        <YStack gap={10} style={styles.centerEverything} >
          <Pressable onPress={async () => {
            const newFlaggedState = !item.flagged;

            // Optimistically update the UI immediately
            setRenderedData((prevData: any) => {
              if (!prevData || !Array.isArray(prevData)) return prevData;
              return prevData.map((data: any) => {
                if (data._id === item._id) {
                  return { ...data, flagged: newFlaggedState };
                }
                return data;
              });
            });

            // Also update retrievedData to keep them in sync
            setRetrievedData((prevData: any) => {
              if (!prevData || !Array.isArray(prevData)) return prevData;
              return prevData.map((data: any) => {
                if (data._id === item._id) {
                  return { ...data, flagged: newFlaggedState };
                }
                return data;
              });
            });

            // Make the API call
            try {
              await flagItem(item._id, newFlaggedState);
            } catch (error) {
              console.error('Failed to flag item:', error);
              // Revert the optimistic update on error
              setRenderedData((prevData: any) => {
                if (!prevData || !Array.isArray(prevData)) return prevData;
                return prevData.map((data: any) => {
                  if (data._id === item._id) {
                    return { ...data, flagged: !newFlaggedState };
                  }
                  return data;
                });
              });
              setRetrievedData((prevData: any) => {
                if (!prevData || !Array.isArray(prevData)) return prevData;
                return prevData.map((data: any) => {
                  if (data._id === item._id) {
                    return { ...data, flagged: !newFlaggedState };
                  }
                  return data;
                });
              });
            }
          }} style={{ zIndex: 10, transform: [{ rotate: '-25deg' }], top: -5, left: 10 }}>
            <Entypo name="flag" size={24} color={item.flagged ? "red" : (theme ? "rgba(0,0,0,0.4)" : "rgba(255,255,255,0.4)")} />
          </Pressable>

          {/* Enrichment Status Indicator */}
          {item.enrichmentStatus && item.enrichmentStatus !== 'pending' && (
            <Pressable
              style={{
                zIndex: 10,
                backgroundColor:
                  item.enrichmentStatus === 'completed' ? '#10b981' :
                    item.enrichmentStatus === 'processing' ? '#f59e0b' :
                      '#ef4444',
                borderRadius: 12,
                padding: 4,
                left: 10
              }}
              onPress={() => {
                const statusMessages = {
                  processing: 'Enrichment In Progress: AI is analyzing this business and gathering contact details.',
                  completed: 'Enrichment Completed: Contact information and alignment score are available.',
                  failed: 'Enrichment Failed: Unable to gather additional information. You can retry enrichment.'
                };
                Alert.alert(
                  'Enrichment Status',
                  statusMessages[item.enrichmentStatus] || 'Unknown status',
                  [{ text: 'OK' }]
                );
              }}
            >
              {item.enrichmentStatus === 'completed' && <FontAwesome5 name="check-circle" size={16} color="white" />}
              {item.enrichmentStatus === 'processing' && <FontAwesome5 name="spinner" size={16} color="white" />}
              {item.enrichmentStatus === 'failed' && <FontAwesome5 name="exclamation-circle" size={16} color="white" />}
            </Pressable>
          )}

          <Checkbox size={"$5"} onCheckedChange={(val: boolean) => {
            checkCallBack(item._id, val)
          }} style={[styles.centerEverything, { left: 10, justifyContent: "center" }]}>
          <Checkbox.Indicator>
            <MaterialIcons name='check' size={24} />
          </Checkbox.Indicator>
          </Checkbox>
          
          {/* User Assignment Button with Popover */}
          <Popover
            open={popoverOpen}
            onOpenChange={(open) => {
              console.log('📋 Popover onOpenChange called (WEB):', open);
              handlePopoverOpen(open);
            }}
            size="$5"
            allowFlip
          >
            <Popover.Trigger>
              <Pressable
                onPress={() => {
                  console.log('👆 Button pressed - opening popover (WEB)');
                  setPopoverOpen(true);
                  // Also manually trigger loadUsers in case onOpenChange doesn't fire
                  setTimeout(() => {
                    console.log('⏰ Timeout - calling loadUsers manually (WEB)');
                    loadUsers();
                  }, 100);
                }}
                style={{
                  zIndex: 10,
                  left: 10,
                  marginTop: 5,
                  padding: assignedUser ? 2 : 6,
                  borderRadius: assignedUser ? 20 : 8,
                  backgroundColor: assignedUser ? (theme ? '#dbeafe' : '#1e3a8a') : (theme ? '#f1f5f9' : '#334155'),
                  alignItems: 'center',
                  justifyContent: 'center',
                  minWidth: assignedUser ? 40 : 40,
                  minHeight: assignedUser ? 40 : 40,
                  borderWidth: assignedUser ? 2 : 0,
                  borderColor: assignedUser ? (theme ? '#93c5fd' : '#1e40af') : 'transparent',
                  position: 'relative'
                }}
                accessibilityLabel={assignedUser ? `Assigned to ${assignedUser.name}` : 'Assign to user'}
                accessibilityHint="Click to assign or change assignment"
              >
                {assignedUser && assignedUser.avatar ? (
                  <AvatarHandler
                    avatar={assignedUser.avatar}
                    avatarImageStyle={{
                      width: 36,
                      height: 36,
                      borderRadius: 18
                    }}
                  />
                ) : assignedUser ? (
                  <View style={{
                    width: 36,
                    height: 36,
                    borderRadius: 18,
                    backgroundColor: theme ? '#3b82f6' : '#1e40af',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}>
                    <Text style={{
                      color: 'white',
                      fontSize: 14,
                      fontWeight: 'bold'
                    }}>
                      {assignedUser.name.charAt(0).toUpperCase()}
                    </Text>
                  </View>
                ) : (
                  <MaterialIcons 
                    name="person-add" 
                    size={18} 
                    color={theme ? '#64748b' : '#94a3b8'} 
                  />
                )}
              </Pressable>
            </Popover.Trigger>
            <Adapt when="sm" platform="touch">
              <Popover.Sheet modal dismissOnSnapToBottom>
                <Popover.Sheet.Frame padding="$4">
                  <Adapt.Contents />
                </Popover.Sheet.Frame>
                <Popover.Sheet.Overlay
                  animation="lazy"
                  enterStyle={{ opacity: 0 }}
                  exitStyle={{ opacity: 0 }}
                />
              </Popover.Sheet>
            </Adapt>
            <Popover.Content
              borderWidth={1}
              borderColor={theme ? '#e2e8f0' : '#374151'}
              enterStyle={{ y: -10, opacity: 0 }}
              exitStyle={{ y: -10, opacity: 0 }}
              elevate
              animation={[
                'quick',
                {
                  opacity: {
                    overshootClamping: true,
                  },
                },
              ]}
              style={{
                backgroundColor: theme ? '#ffffff' : '#1e293b',
                minWidth: 280,
                maxWidth: 320,
                maxHeight: 400,
              }}
            >
              <Popover.Arrow borderWidth={1} borderColor={theme ? '#e2e8f0' : '#374151'} />
              <YStack gap={4} padding="$2">
                <SizableText
                  size="$4"
                  fontWeight="600"
                  color={theme ? '#1e293b' : '#f8fafc'}
                  paddingHorizontal="$2"
                  paddingVertical="$2"
                >
                  Assign to User
                </SizableText>
                <ScrollView maxHeight={350}>
                  <YStack gap={4}>
                    {/* Unassign option */}
                    <Pressable
                      onPress={() => {
                        handleUserSelection(null, item._id);
                        setPopoverOpen(false);
                      }}
                      style={{
                        padding: 12,
                        borderRadius: 8,
                        backgroundColor: theme ? '#f1f5f9' : '#334155',
                      }}
                    >
                      <Text style={{
                        color: theme ? '#1e293b' : '#f8fafc',
                        fontWeight: '600',
                        fontSize: 14
                      }}>
                        Unassign
                      </Text>
                    </Pressable>
                    
                    {/* User list */}
                    {isLoadingUsers ? (
                      <YStack padding="$4" alignItems="center">
                        <Text style={{ color: theme ? '#64748b' : '#94a3b8' }}>Loading users...</Text>
                      </YStack>
                    ) : availableUsers.length === 0 ? (
                      <YStack padding="$4" alignItems="center">
                        <Text style={{ color: theme ? '#64748b' : '#94a3b8' }}>No users available</Text>
                        <Text style={{ color: theme ? '#64748b' : '#94a3b8', fontSize: 10, marginTop: 4 }}>
                          Debug: isLoading={String(isLoadingUsers)}, count={availableUsers.length}
                        </Text>
                      </YStack>
                    ) : (
                      availableUsers.map((user) => (
                        <View
                          key={user._id}
                          style={{
                            padding: 12,
                            borderRadius: 8,
                            backgroundColor: theme ? '#ffffff' : '#1e293b',
                            borderWidth: 1,
                            borderColor: theme ? '#e2e8f0' : '#374151',
                            flexDirection: 'row',
                            alignItems: 'center',
                            gap: 10
                          }}
                        >
                          <Pressable
                            onPress={() => {
                              handleUserSelection(user._id, item._id);
                              setPopoverOpen(false);
                            }}
                            style={{
                              flex: 1,
                              flexDirection: 'row',
                              alignItems: 'center',
                              gap: 10
                            }}
                          >
                            {user.avatar ? (
                              <AvatarHandler
                                avatar={user.avatar}
                                avatarImageStyle={{ width: 32, height: 32, borderRadius: 16 }}
                              />
                            ) : (
                              <View style={{
                                width: 32,
                                height: 32,
                                borderRadius: 16,
                                backgroundColor: theme ? '#3b82f6' : '#1e40af',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <Text style={{
                                  color: 'white',
                                  fontSize: 12,
                                  fontWeight: 'bold'
                                }}>
                                  {user.label.charAt(0).toUpperCase()}
                                </Text>
                              </View>
                            )}
                            <YStack flex={1}>
                              <Text style={{
                                color: theme ? '#1e293b' : '#f8fafc',
                                fontWeight: '500',
                                fontSize: 14
                              }}>
                                {user.label}
                              </Text>
                              {user.email && (
                                <Text style={{
                                  color: theme ? '#64748b' : '#94a3b8',
                                  fontSize: 12
                                }}>
                                  {user.email}
                                </Text>
                              )}
                            </YStack>
                          </Pressable>
                          <Pressable
                            onPress={(e) => {
                              console.log('📅 Calendar button pressed');
                              if (e) {
                                e.stopPropagation();
                                e.preventDefault();
                              }
                              handleDeadlineClick(user._id, item._id, e);
                            }}
                            style={{
                              padding: 8,
                              borderRadius: 6,
                              backgroundColor: theme ? '#f1f5f9' : '#334155',
                              alignItems: 'center',
                              justifyContent: 'center',
                              cursor: 'pointer',
                              zIndex: 1000
                            }}
                          >
                            <MaterialIcons
                              name="event"
                              size={18}
                              color={theme ? '#3b82f6' : '#60a5fa'}
                            />
                          </Pressable>
                        </View>
                      ))
                    )}
                  </YStack>
                </ScrollView>
              </YStack>
            </Popover.Content>
          </Popover>
          {/* Deadline Date Picker */}
          {Platform.OS === 'web' ? (
            <Modal
              isVisible={deadlineDatePickerOpen}
              onBackdropPress={() => {
                setDeadlineDatePickerOpen(false);
                setSelectedUserForDeadline(null);
              }}
              style={{
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <View style={{
                backgroundColor: theme ? 'white' : '#1e293b',
                borderRadius: 16,
                padding: 24,
                minWidth: 300,
                maxWidth: 400,
                zIndex: 10000
              }}>
                <Text style={{
                  fontSize: 18,
                  fontWeight: '600',
                  color: theme ? '#1e293b' : '#f8fafc',
                  marginBottom: 16
                }}>
                  Set Deadline
                </Text>
                <View style={{
                  marginBottom: 20,
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <Text style={{
                    fontSize: 16,
                    color: theme ? '#1e293b' : '#f8fafc',
                    marginBottom: 12
                  }}>
                    Selected: {moment(deadlineDate).format('MMMM DD, YYYY')}
                  </Text>
                  {Platform.OS === 'web' ? (
                    <View style={{ width: '100%' }}>
                      <TextInput
                        value={moment(deadlineDate).format('YYYY-MM-DD')}
                        onChangeText={(text) => {
                          if (text) {
                            const newDate = new Date(text + 'T00:00:00');
                            if (!isNaN(newDate.getTime()) && newDate >= new Date()) {
                              setDeadlineDate(newDate);
                            }
                          }
                        }}
                        placeholder="YYYY-MM-DD"
                        style={{
                          width: '100%',
                          padding: 12,
                          borderRadius: 8,
                          borderWidth: 1,
                          borderColor: theme ? '#e2e8f0' : '#374151',
                          backgroundColor: theme ? 'white' : '#1e293b',
                          color: theme ? '#1e293b' : '#f8fafc',
                          fontSize: 16,
                          minHeight: 50
                        }}
                        {...(Platform.OS === 'web' && {
                          // @ts-ignore - web-specific HTML attributes
                          type: 'date',
                          min: moment().format('YYYY-MM-DD')
                        })}
                      />
                    </View>
                  ) : null}
                </View>
                <View style={{
                  flexDirection: 'row',
                  gap: 12,
                  marginTop: 20,
                  justifyContent: 'flex-end'
                }}>
                  <Pressable
                    onPress={() => {
                      setDeadlineDatePickerOpen(false);
                      setSelectedUserForDeadline(null);
                    }}
                    style={{
                      paddingHorizontal: 16,
                      paddingVertical: 8,
                      borderRadius: 8,
                      backgroundColor: theme ? '#f1f5f9' : '#334155'
                    }}
                  >
                    <Text style={{
                      color: theme ? '#1e293b' : '#f8fafc',
                      fontWeight: '500'
                    }}>
                      Cancel
                    </Text>
                  </Pressable>
                  <Pressable
                    onPress={() => handleDeadlineConfirm(deadlineDate)}
                    style={{
                      paddingHorizontal: 16,
                      paddingVertical: 8,
                      borderRadius: 8,
                      backgroundColor: '#3b82f6'
                    }}
                  >
                    <Text style={{
                      color: 'white',
                      fontWeight: '500'
                    }}>
                      Set Deadline
                    </Text>
                  </Pressable>
                </View>
              </View>
            </Modal>
          ) : null}
          {assignedUser && (
            <Text style={{
              fontSize: 10,
              color: theme ? '#64748b' : '#94a3b8',
              marginTop: 2,
              left: 10,
              maxWidth: 50,
              textAlign: 'center'
            }} numberOfLines={1}>
              {assignedUser.name}
            </Text>
          )}
        </YStack>
        {/* <XStack gap={20} style={{ overflow: "hidden", flexDirection: 'row', position: "absolute", right: 90, top: 10, justifyContent: "center", alignSelf: "auto", zIndex: 1 }}>
          <AntDesign name="delete" size={24} color="red" />
        </XStack> */}
        <DataType innerStyle={{ paddingBottom: 0 }} />
      </XStack>), [itemTags, marked, item, theme, assignedUser, popoverOpen, availableUsers, isLoadingUsers, deadlineDatePickerOpen, deadlineDate, selectedUserForDeadline]);
  };


  const _handleShowScanner = useCallback(() => {
    bottomDrawerRef.current?.showCamera();
  }, []);

  const checkCallBack = useCallback((id, value) => {
    const currentMarked = markedRef.current;
    const index = currentMarked.indexOf(id);

    if (value) {
      if (index === -1) {
        markedRef.current = [...currentMarked, id];
      }
    } else {
      if (index > -1) {
        const newMarked = [...currentMarked];
        newMarked.splice(index, 1);
        markedRef.current = newMarked;
      }
    }
  }, []);

  const handleMoveData = useCallback(async (folderId: string) => {
    const itemsToMove = markedRef.current;
    
    if (!itemsToMove || itemsToMove.length === 0) {
      showAlert('No items selected', 'Please select items to move.');
      return;
    }

    const confirmed = await showConfirm(
      'Confirm Move',
      `Please select target data set that you want to move ${itemsToMove.length} item(s) to`,
      {
        cancelText: 'Cancel',
        confirmText: 'Move',
        customCallbackComponent: <DataSetSelection /> 
      }
    );

    if (confirmed) {
      await handleDataItemMove({ ids: itemsToMove, folderId: confirmed }).then(() => {
        setRetrievedData((prevData) => 
        prevData.filter((item)=> !itemsToMove.includes(item?.id)));
        setRenderedData((prevRenderedData) =>
          prevRenderedData.filter((item) => !itemsToMove.includes(item._id))
        );
        // Clear the marked items
        markedRef.current = [];
    })
      // Perform your move logic here
    } else {
      await showAlert('Cancelled', 'No items were moved.');
markedRef.current = [];
    }
  },[])


  const handleBulkDelete = useCallback(async () => {
    const itemsToDelete = markedRef.current;

    if (!itemsToDelete || itemsToDelete.length === 0) {
      return;
    }

    const confirmed = await showConfirm(
      'Confirm Bulk Delete',
      `Are you sure you want to delete ${itemsToDelete.length} item(s)? This cannot be undone.`,
      {
        cancelText: 'Cancel',
        confirmText: 'Delete',
      }
    );

    if (confirmed) {
      await handleDataItemDelete({ ids: itemsToDelete }).then(()=>{
        setRetrievedData((prevData) =>
          prevData.filter((item) => !itemsToDelete.includes(item._id))
        );
        // Update the renderedData state to reflect the changes immediately
        setRenderedData((prevRenderedData) =>
          prevRenderedData.filter((item) => !itemsToDelete.includes(item._id))
        );
        // Clear the marked items
        markedRef.current = [];
      })
      // Perform your delete logic here
    } else {
      await showAlert('Cancelled', 'No items were deleted.');
      //Reset the markedRef
      markedRef.current = [];
    }
  }, []);

  const handleCustomizeView = useCallback(() => {
    navigation.navigate('ComponentDesigner', {
      dataId: requestId,
      dataTitle: title,
      onSave: (customView) => {
        // Handle saved custom view
        console.log('Custom view saved:', customView);
        // Refresh data to get updated custom views
        refetch();
      }
    });
  }, [navigation, requestId, title, refetch]);

  const handleViewSelection = useCallback((viewId: string | null) => {
    setSelectedCustomView(viewId);
  }, []);

  const _recallModal = useCallback(() => {
    bottomDrawerRef.current?.hideSheet()
  }, []);


  const SwipeSearch = ({ events }) => {
    const [xyValue, setXYValue] = useState(0);
    const translateX = useSharedValue(xyValue);
    const panRef = useRef();

    const handlePanGesture = ({ nativeEvent }) => {
      const { translationX, translationY, state, absoluteX, absoluteY } = nativeEvent;
      if (state === State.ACTIVE) {
        translateX.value = translationX;

      }
      if (state === State.END) {
        if (translateX.value < -1) {
          translateX.value = withSpring(0);
          handleStatsSwitch(true);
          // Handle your logic when translationX is less than -1
        } else if (translateX.value > 1) {
          translateX.value = withSpring(0);
          handleStatsSwitch(false);

          // Handle your logic when translationX is greater than 1
        }
      }
    };


    return (
      <PanGestureHandler ref={panRef} onGestureEvent={handlePanGesture} onHandlerStateChange={handlePanGesture}>
        <View style={{ borderBottomStartRadius: 20, borderBottomEndRadius: 20, backgroundColor: 'white', maxHeight: 80 }} >
          {
            showStats ?
              <Animated.View style={[{ maxHeight: 80, flexDirection: 'row', shadowRadius: 20, shadowOpacity: .2, gap: 10, paddingVertical: 15, alignContent: 'space-around', paddingHorizontal: '7%', transform: [{ translateX: translateX }] }]}>
                <View style={[styles.centerEverything, { flex: 1, backgroundColor: 'white', borderRadius: 100, maxWidth: 70, height: 70, paddingVertical: 5 }]}>
                  <Title style={{ fontSize: 26 }}>{events}</Title>
                  <Text>Docs</Text>
                </View>
                <View style={[styles.centerEverything, { flex: 1, backgroundColor: 'white', borderRadius: 100, maxWidth: 70, height: 70, paddingVertical: 5 }]}>
                  <Title style={{ fontSize: 26 }}>5</Title>
                  <Text style={{ fontSize: 10 }}>AI</Text>
                  <Text style={{ fontSize: 8 }}>actions</Text>
                </View>
                <View style={[styles.centerEverything, { flex: 1, backgroundColor: 'white', borderRadius: 100, maxWidth: 70, height: 70, paddingVertical: 5 }]}>
                  <Title style={{ fontSize: 26 }}>3</Title>
                  <Text>Users</Text>
                </View>
                <View style={[styles.centerEverything, { flex: 1, backgroundColor: 'white', borderRadius: 100, maxWidth: 70, height: 70, paddingVertical: 5 }]}>

                </View>
              </Animated.View>
              :
              <Animated.View style={{ transform: [{ translateX: translateX }] }}>
                <SearchComponent backButton callback={handleSearch} />
              </Animated.View>
          }
        </View>
      </PanGestureHandler>
    )
  }

  const calculateColumns = () => {
    if (Dimensions.get('window').width > 500) {
      const columns = Math.floor(listWidth / 500);
      return columns;
    } else {
      return 1;
    }
  }

  const handleWidthChange = (width) => {
    debounce(() => setListWidth(width), 200)();
  }

  return useMemo(() => (
    <View style={{ flex: 1, paddingBottom: 50 }}>
      <DefaultScreen style={{ maxWidth: "97%", paddingTop: 10 }} screenTitle={title} noMargin backButton scrollDisabled={true} searchBar={{
        callback: handleSearch,
        customIcons: Platform.OS ==='web' ?  [
          {
            functionName: "filter",
            function: () => {
              setShowFilters(true);
            },
            icon: <Animatable.View style={{ padding: 5, borderRadius: 10, backgroundColor: hasActiveFilters(filters) ? '#3B82F6' : '#9E9E9E', marginRight: 5 }}>
              <MaterialIcons name="filter-list" size={18} color="white" />
            </Animatable.View>
          },
          {
            functionName: "delete",
            function: () => {
              handleBulkDelete()
            },
            icon: <Animatable.View style={{ padding: 5, borderRadius: 10, backgroundColor: markedRef.current.length > 0 ? 'red' : "grey", marginRight: 0 }}><AntDesign name="delete" size={18} color="white" /></Animatable.View>
          },
          {
          functionName: 'changeView',
          function: changeListView,
          icon: listHorizontal ? <FontAwesome5 name="th-list" size={18} color="white" /> : <SimpleLineIcons name="grid" size={18} color="white" />,
        }, 
        {
            functionName: "switchTable",
            function: _handleTableSwitch,
            icon: showTable ? <Feather name="grid" size={18} color="white" /> : <AntDesign name={"table"} size={18} color="white" />
          },
          {
            functionName:'moveData',
            function: handleMoveData,
            icon: <Feather name="arrow-up-right" size={18} color="white" />
          },
          {
            functionName: 'customizeView',
            function: handleCustomizeView,
            icon: <MaterialIcons name="design-services" size={18} color="white" />
          },
          {
            functionName: 'selectView',
            function: () => {
              if (customViews.length === 0) {
                Alert.alert('No Custom Views', 'No custom views available. Create one using the Customize View button.');
                return;
              }

              const options = [
                { text: 'Default View', onPress: () => handleViewSelection(null) },
                ...customViews.map(view => ({
                  text: view.name,
                  onPress: () => handleViewSelection(view._id)
                })),
                { text: 'Cancel', style: 'cancel' }
              ];

              Alert.alert('Select View', 'Choose a view to display your data:', options);
            },
            icon: <MaterialIcons name="view-list" size={18} color="white" />
          }
        ] : [
            {
              functionName: "filter",
              function: () => {
                setShowFilters(true);
              },
              icon: <MaterialIcons name="filter-list" size={14} color={hasActiveFilters(filters) ? '#3B82F6' : 'white'} />
            },
            {
              functionName: "delete",
              function: () => {
                handleBulkDelete()
              },
              icon: <AntDesign name="delete" size={14} color="white" />
            },
            {
              functionName:'moveData',
              function: handleMoveData,
              icon: <Feather name="arrow-up-right" size={14} color="white" />
            }
          ]
      }}>
        {/* <View style={{ zIndex: 1, marginHorizontal: -15 }}>
        <SwipeSearch events={retrievedData?.length} />
      </View> */}
        <CustomerImageModal />
        <View style={{ flex: 1, paddingHorizontal: 20 }}>

          {isLoading ? (
            <View style={{
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: 400
            }}>
              <LottieView
                source={require('@assets/animations/spin-leaf-loader.json')}
                autoPlay
                loop
                style={{ width: 200, height: 200 }}
              />
              <Title style={{
                marginTop: 20,
                color: theme ? '#64748b' : '#94a3b8',
                fontSize: 16,
                fontWeight: '500'
              }}>
                Loading data...
              </Title>
            </View>
          ) : !isLoading && retrievedData ? (
            <View
              style={{ flex: 1, paddingRight: 20 }}
              onLayout={e => handleWidthChange(e.nativeEvent.layout.width)}
            >
              {
              showTable && retrievedData && Platform.OS === 'web' ? (
                <View style={{ flex: 1, alignSelf: 'stretch', minWidth: '100%', padding: 10, height: '100%', borderRadius: 20, margin: 20, paddingBottom: 30 }}>
                    <ProductionDataTable
                      data={retrievedData}
                      columns={generateColumnsFromData(retrievedData)}
                      loading={isLoading}
                      onRowClick={(row) => {
                        // Handle row click - navigate to detail view
                        console.log('Row clicked:', row);
                      }}
                      onRowEdit={(row) => {
                        // Handle row edit
                        console.log('Edit row:', row);
                      }}
                      onRowDelete={(row) => {
                        // Handle row delete
                        console.log('Delete row:', row);
                      }}
                      onSelectionChange={(selectedRows) => {
                        console.log('Selected rows:', selectedRows);
                      }}
                      onBulkAction={(action, selectedRows) => {
                        console.log('Bulk action:', action, selectedRows);
                      }}
                      enableSelection={true}
                      enableSorting={true}
                      enableFiltering={true}
                      enableExport={true}
                      enableInlineActions={true}
                      pageSize={20}
                      showRowNumbers={true}
                      stickyHeader={true}
                      emptyStateMessage="No data items found"
                    />
                </View>
              ) : (
                    <FlatList
                      key={`data-browser-${listWidth > 1000 ? 2 : 1}`}
                      style={{ flex: 1 }}
                      data={renderedData}
                      numColumns={listWidth > 1000 ? 2 : 1}
                      keyExtractor={(item, index) => item._id || index.toString()}
                      renderItem={({ item, index }) => {
                        return (
                          <View style={{
                            flex: 1,
                            margin: 10,
                            width: listWidth > 1000 ? '50%' : '100%',
                            maxWidth: listWidth > 1000 ? '50%' : '100%'
                          }}>
                            <RenderItem checkCallback={checkCallBack} item={item} index={index} />
                          </View>
                        );
                      }}
                      ListEmptyComponent={() => (
                        <View style={{
                          flex: 1,
                          borderRadius: 20,
                          alignItems: 'center',
                          minHeight: 200,
                          minWidth: '100%',
                          justifyContent: 'center',
                          alignContent: 'center',
                          alignSelf: 'stretch',
                          height: "100%",
                          margin: 10
                        }}>
                          <LottieView
                            source={require("@assets/animations/magnifExample.json")}
                            autoPlay
                            loop
                            style={{ width: 200, height: 200, alignSelf: 'center' }}
                          />
                          <Title style={{ textAlign: 'center' }}>No data in this dataset</Title>
                        </View>
                      )}
                      contentContainerStyle={{ paddingBottom: 20 }}
                      showsVerticalScrollIndicator={true}
                      removeClippedSubviews={false}
                />
              )
              }
            </View>
          )
            :
            (null)
          }

          {/* Integrated Pagination and Sorting Controls */}
          {!isDocumentType && paginationState && (
            <Pagination
              pagination={paginatedData?.data?.pagination ? {
                currentPage: paginatedData.data.pagination.currentPage || 1,
                totalPages: paginatedData.data.pagination.totalPages || 1,
                totalRecords: paginatedData.data.pagination.totalRecords || 0,
                hasNextPage: paginatedData.data.pagination.hasNextPage || false,
                hasPrevPage: paginatedData.data.pagination.hasPrevPage || false,
                nextPage: paginatedData.data.pagination.nextPage,
                prevPage: paginatedData.data.pagination.prevPage
              } : {
                currentPage: 1,
                totalPages: 1,
                totalRecords: retrievedData?.length || 0,
                hasNextPage: false,
                hasPrevPage: false,
                nextPage: undefined,
                prevPage: undefined
              }}
              pageSize={paginationState.pageSize}
              onPageChange={handlePageChange}
              onPageSizeChange={handlePageSizeChange}
              pageSizeOptions={[5, 10, 20, 50]}
              showPageSizeSelector={true}
              showTotalRecords={true}
              showSorting={true}
              sortBy={paginationState.sortBy}
              sortOrder={paginationState.sortOrder}
              onSortByChange={handleSortByChange}
              onSortOrderChange={handleSortOrderChange}
              sortByOptions={[
                { value: 'createdAt', label: 'Created Date' },
                { value: 'updatedAt', label: 'Updated Date' },
                { value: 'title', label: 'Title' },
                { value: 'name', label: 'Name' }
              ]}
              style={{ marginTop: 20 }}
            />
          )}
      </View>
      </DefaultScreen>
      {
        Platform.OS != 'web' &&
          <AddDataModal owner={defaultData?.createdBy} callback={_handleAddItem} actions={() => {
          return (<Animatable.View useNativeDriver animation={'slideInUp'} style={{ gap: 2, flexDirection: 'row', flex: 5, maxHeight: 80, overflow: 'hidden', paddingHorizontal: 5, paddingRight: 10 }}>
              <Button
                onPress={() => _handleShowScanner()}
              iconOnly
              icon={(<Ionicons name="qr-code" size={24} color="white" style={[styles.centerEverything, { left: 60 }]} />)}
              customStyle={{ borderTopStartRadius: 20, borderBottomStartRadius: 20, borderStartEndRadius: 0, borderEndEndRadius: 0, alignContent: 'center', alignItems: 'center', justifyContent: 'center', borderRadius: 0, shadowOpacity: 0, alignSelf: 'stretch', minWidth: '50%', position: 'relative' }}
                iconColor='white'
              />
              <Button
              onPress={() => { bottomDrawerRef.current?.showSheet() }}
                icon={"plus"}
                inverse
                buttonText={"Add data"}
              customStyle={{ borderTopEndRadius: 20, borderBottomEndRadius: 20, borderStartStartRadius:0, borderEndStartRadius:0, alignContent: 'center', alignItems: 'center', justifyContent: 'center', borderRadius: 0, shadowOpacity: 0, alignSelf: 'stretch', minWidth: '50%', position: 'relative' }}
              />
          </Animatable.View>)
        }} ref={bottomDrawerRef} createdAt={defaultData?.createdAt} {...{ dataTitle: defaultData?.dataTitle, dataSchema: defaultData?.dataSchema, dataId: defaultData?._id }} refreshFunction={_recallModal} />
      }
      <DataBrowserFilters
        visible={showFilters}
        onClose={() => setShowFilters(false)}
        onApplyFilters={handleApplyFilters}
        currentFilters={filters}
        availableTags={itemTags}
        availableUsers={getAvailableUsersForFilter()}
      />
    </View>
  ), [listWidth, paginatedData, theme, renderedData, showTable, title, defaultData, isLoading, requestId, handleSearch, handleStatsSwitch, onRefresh, calculateColumns, _handleShowScanner, _recallModal, filters, showFilters, itemTags, getAvailableUsersForFilter])
}
export default DataBrowserScreen;
